/**
 * Inline "add your own" input with brand-safety. Every member-typed custom chip is screened with
 * the SAME guardrails the server enforces (sanitize + injection + hostility + profanity) BEFORE it
 * is accepted; a failing entry gets a gentle inline rejection and is not added. Positivity-only.
 * @see shared/src/guardrails.ts (screenCustomChip)
 */
import { useState } from 'react';
import { screenCustomChip } from '@pghbites/shared';

interface AddYourOwnProps {
  label: string;
  onAdd: (value: string) => void;
}

export function AddYourOwn({ label, onAdd }: AddYourOwnProps) {
  const [draft, setDraft] = useState('');
  const [error, setError] = useState<string | null>(null);

  const commit = () => {
    const result = screenCustomChip(draft);
    if (!result.ok) {
      setError(result.message);
      return;
    }
    onAdd(result.value);
    setDraft('');
    setError(null);
  };

  return (
    <div className="add-own-wrap">
      <div className="add-own">
        <input
          className="field-input"
          type="text"
          value={draft}
          maxLength={40}
          placeholder="➕ Add your own"
          aria-label={`Add your own to ${label}`}
          aria-invalid={error ? true : undefined}
          onChange={(e) => {
            setDraft(e.target.value);
            if (error) setError(null);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              commit();
            }
          }}
        />
        <button type="button" className="chip add-btn" onClick={commit} disabled={!draft.trim()}>
          Add
        </button>
      </div>
      {error && (
        <p className="add-own-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
